import ericStevensIntro from "./eric-stevens-jr-introduction";

const posts = [ericStevensIntro]; // Ensure this array is not empty

console.log("Blog index.js Loaded. Posts:", posts); // Debugging output

export default posts;
